let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a40p8")).then(() => parcelRequire('koTfG'));